import api from './utils/api.js';

const actions = {
  getInit(context) {
    let params = {
      requiredData: {
        getSites: 1,
        getHistoryPanelHTMLV3: 1,
        getPluginsAndThemesV3: 1,
        getGroupsSitesV3: 1,
        getSitesUpdatesV3: 1,
        getFavouritesPluginsAndThemesV3: 1,
        getSitesBackupsV3: 1,
        getClientUpdateAvailableSiteIDs: 1,
        getAppInfoV3: 1,
        getSettingsAllV3: 1,
        initialCheckUpdateV3: 1
      }
    };
    return api
      .post(params)
      .then(response => {

        context.commit('SET_SITES', response.data.getSites);
        context.commit('SET_GROUPS', response.data.getGroupsSitesV3);
        context.commit('SET_SITES_UPDATES', response.data.getSitesUpdatesV3);
        context.commit('SET_BACKUPS', response.data.getSitesBackupsV3);
        context.commit(
          'SET_FAVORITES',
          response.data.getFavouritesPluginsAndThemesV3
        );
        context.commit(
          'SET_PLUGINS_AND_THEMES',
          response.data.getPluginsAndThemesV3
        );
        context.commit(
          'SET_PANEL_HISTORY',
          response.data.getHistoryPanelHTMLV3
        );
        context.commit(
          'SET_CLIENT_PLUGIN_UPDATES',
          response.data.getClientUpdateAvailableSiteIDs
        );
        context.commit('SET_SETTINGS', response.data.getSettingsAllV3);
        context.commit('SET_APPINFO', response.data.getAppInfoV3);
        context.commit(
          'SET_PANEL_UPDATE_INFO',
          response.data.initialCheckUpdateV3
        );
      })
      .catch(error => {
        context.commit('API_FAILURE', error);
        return Promise.reject(error);
      });
  },
  getPanelHistory(context) {
    let params = {
      requiredData: {
        getHistoryPanelHTMLV3: 1
      }
    };
    return api
      .post(params)
      .then(response => {
        context.commit(
          'SET_PANEL_HISTORY',
          response.data.getHistoryPanelHTMLV3
        );
        return Promise.resolve(response);
      })
      .catch(error => context.commit('API_FAILURE', error));
  },
  sendAction(context, payload) {
    if (payload.ignorePanelHistory) {
      delete payload.ignorePanelHistory;
    } else {
      if (typeof payload.requiredData === 'undefined') {
        payload.requiredData = {};
      }
      payload.requiredData['getHistoryPanelHTMLV3'] = 1;
    }
    return api
      .post(payload)
      .then(response => {

        if (response.data.getHistoryPanelHTMLV3) {
          context.commit(
            'SET_PANEL_HISTORY',
            response.data.getHistoryPanelHTMLV3
          );
        }
        return Promise.resolve(response);
      })
      .catch(error => {

        context.commit('API_FAILURE', error);
      });
  }
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/actions.js